import { apiClient } from '@/shared/services/http/http.service'
import { SURVEY_ENDPOINTS } from '../constants/endpoints.constant.js'

export async function closeSurvey(id) {
  const url = SURVEY_ENDPOINTS.CLOSE.replace(':id', id)
  const response = await apiClient('generic-survey').post(url)
  if (response.status < 200 || response.status >= 300) {
    throw new Error(`Close survey failed with status ${response.status}`)
  }
  return { id, status: 'closed' }
}
